/**
 * Footer page
 */
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { dictionary,cnfsystem} from 'mdoc/admin/axios'
import {
    Button,
    Typography,
} from '@material-ui/core';

const styles = theme => ({
    footer: {
        boxSizing: 'border-box',
        backgroundColor: '#2196f3',
        width: '100%',
        height: 53,
        position: 'fixed',
        bottom:0,
        zIndex:9
    },
});
class Footer extends React.Component {
    state = {
        dictWord: {
            copyright: '',
            about: '',
            privacypolicy: '',
            help: '',
        },
    };
    componentWillMount() {
        this.start(this.state);
    }
    start = (state) => {
        let dict = {}
        dictionary(state.dictWord).then(res => {
            for (let key in res) {
                let val = res[key];
                dict[val.dictKey] = val.dictValue;
            }
            this.setState({
                dictWord: dict,
            })
        });
    }

    onLocationUrl = (link_key)=> event =>{
        cnfsystem(link_key).then(res =>{
            if(res)window.open(res);
        })
    }

    render() {
        const { classes } = this.props;
        const { dictWord } = this.state;
        return (
            <Typography id="footer" className={classes.footer} component="div">
                <Typography variant="subtitle1" align="right" component="div">
                    <Button onClick={this.onLocationUrl("about_link")} variant="text" size="small" style={{ color: '#ffffff', fontSize: '12px' }} className={classes.button}>
                        {dictWord.about}
                    </Button>
                    <Button onClick={this.onLocationUrl("privacypolicy_link")} variant="text" size="small" style={{ color: '#ffffff', fontSize: '12px' }} className={classes.button}>
                        {dictWord.privacypolicy}
                    </Button>
                    <Button onClick={this.onLocationUrl("help_admin_link")} variant="text" size="small" style={{ color: '#ffffff', fontSize: '12px' }} className={classes.button}>
                        {dictWord.help}
                    </Button>
                </Typography>
                <Typography variant="body1" align="center" style={{ color: '#ffffff', fontSize: '12px' }} gutterBottom={false}>
                    {dictWord.copyright}
                </Typography>
            </Typography>
        )
    }
}

Footer.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withStyles(styles)(Footer);